import IntersectionObserver from "intersection-observer";
import LazyLoad from "vanilla-lazyload";

var myLazyLoad = new LazyLoad({
    elements_selector: ".lazyBlur",
    load_delay: 300,
    callback_reveal: (el)=>{
        $(el).removeClass('lazyBlur').removeAttr('data-bg')
    },
});